// extracted by mini-css-extract-plugin
export default {"chart":"stats_chart__3JnE9","container":"stats_container__UAzT4","stats":"stats_stats__hMaXG"};